import React from 'react';

import Section from '@dashboard/components/sections/Section';
import { usePlatformCountsQuery } from '@dashboard/generated/wp/administrator';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { useCurrentPlatformId } from '../hooks';

import ModelCountRow from './ModelCountRow';

export default function ModelCounts() {
  const platformId = useCurrentPlatformId();
  const { data } = usePlatformCountsQuery({ variables: { id: platformId } });

  return (
    <Section title="Models" variant="secondary">
      <TableContainer>
        <Table size="small" sx={{ 'th,td': { border: 0 } }}>
          <TableHead>
            <TableRow>
              <TableCell width="100%">Model name</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <ModelCountRow label="API Keys" count={data?.Platform.apiKeysCount} />
            <ModelCountRow label="Contacts" count={data?.Platform.contactsCount} />
            <ModelCountRow label="Contact Groups" count={data?.Platform.contactsGroupCount} />
            <ModelCountRow label="Contact Group Contacts" count={data?.Platform.contactsGroupContactsCount} />
            <ModelCountRow label="Domain Name Verifications" count={data?.Platform.domainNameVerificationsCount} />
            <ModelCountRow label="Email Messages" count={data?.Platform.emailMessagesCount} />
            <ModelCountRow label="Email Message Batches" count={data?.Platform.emailMessagesBatchesCount} />
            <ModelCountRow label="Platform Users" count={data?.Platform.platformUsersCount} />
            <ModelCountRow label="Request Logs" count={data?.Platform.requestLogsCount} />
            <ModelCountRow label="Templates" count={data?.Platform.templatesCount} />
            <ModelCountRow label="Template Images" count={data?.Platform.templateImagesCount} />
            <ModelCountRow label="Timeline Log Items" count={data?.Platform.timelineLogItemsCount} />
            <ModelCountRow label="Verified Email Addresses" count={data?.Platform.verifiedEmailAddressesCount} />
            <ModelCountRow label="Workflows" count={data?.Platform.workflowsCount} />
            <ModelCountRow label="Workflow Runs" count={data?.Platform.workflowRunsCount} />
            <ModelCountRow label="Workflow Run Commands" count={data?.Platform.workflowRunCommandsCount} />
          </TableBody>
        </Table>
      </TableContainer>
    </Section>
  );
}
